export const parseTickers = (text: string): string[] => {
  const tickerPattern = /[A-Za-z0-9]+/g;
  const tickers = text.match(tickerPattern) || [];

  return tickers;
};
